import { READY_CHECK_MS } from '../../shared/config';
import type { PlayerView, ReadyCheckView } from '../../shared/protocol';

export type ReadyPrompt = 'guest' | 'host' | null;

/**
 * Which prompt this browser sees: guests until the server lists them as confirmed, the host
 * (who waits rather than confirms) for the whole check.
 */
export function readyPrompt(
  readyCheck: Readonly<ReadyCheckView> | null,
  players: readonly Readonly<Pick<PlayerView, 'id' | 'ready' | 'host'>>[],
  meId: string,
): ReadyPrompt {
  if (readyCheck === null) return null;
  const me = players.find((player) => player.id === meId);
  if (!me) return null;
  if (me.host) return 'host';
  return me.ready === false ? 'guest' : null;
}

/**
 * How far the check has run at `serverNow`, so a prompt opened late (reconnect, late join)
 * shows the remaining undimmed share rather than restarting it.
 */
export function readyCheckElapsedMs(
  readyCheck: Readonly<Pick<ReadyCheckView, 'endAt'>>,
  now: number,
): number {
  return Math.min(READY_CHECK_MS, Math.max(0, now - (readyCheck.endAt - READY_CHECK_MS)));
}

/** The `.ready-button` dimming variables for a check `elapsedMs` into its window. */
export function readyTimingStyle(elapsedMs: number): string {
  return `--ready-duration: ${READY_CHECK_MS}ms; --ready-elapsed: -${elapsedMs}ms`;
}
